import { View, Text, StyleSheet, ActivityIndicator } from "react-native";
import React from "react";

import Notification from "@assets/svg/Notification";
import { colors } from "@constants/theme";
import t from "@constants/localization";

const PATH = "screens/Shop/components/NoUpdates";

const NoUpdates = ({ isFetching }) => {
  return (
    <View style={styles.container}>
      {isFetching ? (
        <ActivityIndicator color="#FF7A00" size="large" />
      ) : (
        <View style={styles.container}>
          <Notification />
          <Text style={styles.text1}>{t(`${PATH}/noUpdates`)}</Text>
          <Text style={styles.text2}>{t(`${PATH}/msg`)}</Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    backgroundColor: colors.white,
  },
  text1: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 18,
    fontWeight: "600",
    lineHeight: 27,
    textAlign: "center",
    color: colors.mediumBlack,
    marginVertical: 16,
  },
  text2: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
    fontWeight: "400",
    lineHeight: 20,
    textAlign: "auto",
    color: colors.lightBlack,
  },
});

export default NoUpdates;
